import { React, useState } from "react";
import { useNavigate } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import "./ShareClassOverview.css";

import ReturnToClassOverview from "./ReturnToClassOverview";
import ShareClassFunction from "./ShareClassFunction";
import SubmitShareButton from "./SubmitShareButton";
import AdditionalColleaguesButton from "./AdditionalColleaguesButton";
import GradeCard from "./GradeCard";
import {
  approveClassAccessRequest,
  shareClass,
} from "../services/APIClient";

function ShareClassOverview(props) {
  const navigate = useNavigate();
  let classDetails = props.classDetails.classDetails;
  let teacherid = props.classDetails.classDetails.teacherId;
  let gradeLevel = props.gradeLevel;
  let name = props.name;
  let teachers = props.teachers.teachers;
  let sharedWith = props.sharedWith.sharedWith;
  let gradeLevel1 = classDetails.grade_level1;
  let gradeLevel2 = classDetails.grade_level2;
  let gradeLevel3 = classDetails.grade_level3;
  let trialClass = classDetails.trail_class;
  let rollNumber = props.rollNumber;
  let teacherEmail = props.teacherEmail;
  let schoolid = props.schoolid;
  let requestedTeacherId = props.requestedTeacherId;
  let requestId = props.requestId;

  let teacherName = teachers.find((teacher) => teacher.id === teacherid)?.name;
  let validRequestedTeacherId =
    Boolean(requestedTeacherId) &&
    requestedTeacherId !== teacherid &&
    teachers.some((teacher) => teacher.id === requestedTeacherId)
      ? requestedTeacherId
      : null;
  let isRequestedTeacherAlreadyShared =
    validRequestedTeacherId &&
    sharedWith?.some((shared) => shared.id === validRequestedTeacherId);

  console.log(teacherName);

  let [sharedClassArray, setSharedClassArray] = useState([]);
  let [unSharedClassArray, setUnSharedClassArray] = useState([]);
  let [isRequestedTeacherSelected, setIsRequestedTeacherSelected] = useState(
    Boolean(validRequestedTeacherId)
  );
  let [isRequestedTeacherShared, setIsRequestedTeacherShared] = useState(
    Boolean(isRequestedTeacherAlreadyShared)
  );
  let [shareError, setShareError] = useState("");

  const handleSubmitShare = async (event) => {
    setShareError("");

    if (!validRequestedTeacherId || !isRequestedTeacherSelected) {
      return;
    }

    if (isRequestedTeacherShared && !requestId) {
      return;
    }

    event.preventDefault();

    if (!isRequestedTeacherShared) {
      try {
        await shareClass(classDetails.id, validRequestedTeacherId);
        setIsRequestedTeacherShared(true);
      } catch (error) {
        console.error("Error sharing class with requested teacher:", error);
        setShareError(
          "We couldn't share this class with the requested teacher. Please try again."
        );
        return;
      }
    }

    if (requestId) {
      try {
        await approveClassAccessRequest(requestId);
      } catch (error) {
        console.error("Error completing class access request:", error);
        setShareError(
          "The class was shared, but we couldn't complete the access request. Please try again."
        );
        return;
      }
    }

    navigate(`/class/detail`, {
      state: {
        classDetails: { classDetails },
        teachers: { teachers },
        name: { name },
        gradeLevel: { gradeLevel },
        schoolid: { schoolid },
      },
    });
  };

  return (
    <div className="class-overview-container">
      <Container className="container-shape">
        <Row className="page-description-bar">
          <Col className="col-8">
            <h2 className="page-description-header">Share Class</h2>
            <p>
              You can add users associated with this school to your class or
              invite users to join ALPACA using their email address.
            </p>
          </Col>
          <Col className="col-4">
            <Row>
              <Col className="col-6">
                <GradeCard
                  gradeLevel={gradeLevel}
                  gradeLevel1={gradeLevel1}
                  gradeLevel2={gradeLevel2}
                  gradeLevel3={gradeLevel3}
                  trialClass={trialClass}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <hr></hr>
        <AdditionalColleaguesButton
          rollNumber={rollNumber}
          teacherEmail={teacherEmail}
        />
        <br></br>
        <Row>
          <Col>
            <p>
              The users below are associated with your school. You can share
              your class with them.
            </p>
            <p>
              This class can't be un-shared with {teacherName} as they created
              the classroom - please email info@alpaca-assessment.com if you
              need assistence with this.
            </p>
            <hr></hr>
            <ShareClassFunction
              classDetails={classDetails}
              teachers={teachers}
              sharedWith={sharedWith}
              requestedTeacherId={validRequestedTeacherId}
              onRequestedTeacherSelectionChange={
                setIsRequestedTeacherSelected
              }
              setSharedClassList={setSharedClassArray}
              setUnSharedClassList={setUnSharedClassArray}
            />
            {shareError && <p>{shareError}</p>}
          </Col>
          <div className="shareclass-button-placer">
            <ReturnToClassOverview
              classDetails={classDetails}
              teachers={teachers}
              name={name}
              gradeLevel={gradeLevel}
              rollNumber={rollNumber}
              teacherEmail={teacherEmail}
              schoolid={schoolid}
            />
            <div onClickCapture={handleSubmitShare}>
              <SubmitShareButton
                classDetails={classDetails}
                teachers={teachers}
                name={name}
                gradeLevel={gradeLevel}
                schoolid={schoolid}
              />
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default ShareClassOverview;
